var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadFile = function SvgUploadFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    fillRule: "evenodd",
    d: "M3.805 3.802a.667.667 0 1 1-.943-.944L5.53.194c.26-.26.682-.26.942 0l2.667 2.664a.667.667 0 0 1-.942.944l-1.53-1.528v6.39a.667.667 0 0 1-1.333 0v-6.39zm6.862 6.197V8.665a.667.667 0 0 1 1.333 0V10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.665a.667.667 0 0 1 1.333 0V10c0 .368.299.666.667.666h8a.667.667 0 0 0 .667-.666",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFile);
export { ForwardRef as ReactComponent };